//filters
export const FILTERS = 'filters';
export const FILTER_PERIOD = 'period';
export const GA_FILTER_PERIOD = 'periodRange';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_NETWORKS = 'networks';
export const FILTER_CLUSTERS = 'clusters';
export const FILTER_PLATFORMS = 'platforms';
export const FILTER_TYPE = 'type';
export const FILTER_SUB_TYPE = 'subType';
export const FILTER_CHANNELS = 'channels';
export const FILTER_MINE_ONLY = 'mineOnly';

// filters dependencies
export const FILTERS_DEPENDENCIES = {
  [FILTER_SUB_TYPE]: [FILTER_TYPE],
  [FILTER_APPLICATIONS]: [FILTER_NETWORKS, FILTER_PLATFORMS],
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS, FILTER_PLATFORMS, FILTER_CLUSTERS],
  [FILTER_CLUSTERS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
  [FILTER_PLATFORMS]: [FILTER_APPLICATIONS, FILTER_NETWORKS],
  [FILTER_AFFILIATES]: [FILTER_APPLICATIONS, FILTER_NETWORKS, FILTER_CLUSTERS],
};

// searchQuery
export const SEARCH_QUERY = 'searchQuery';
export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_PERIOD = 'period';
export const COLUMN_TYPE = 'type';
export const COLUMN_SUB_TYPE = 'subType';
export const COLUMN_CHANNELS = 'channels';
export const COLUMN_DESCRIPTION = 'description';
export const COLUMN_AFFILIATES = 'affiliates';
export const COLUMN_APPLICATIONS = 'applications';
export const COLUMN_NETWORKS = 'networks';
export const COLUMN_CLUSTERS = 'clusters';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_USER = 'user';

// form fields
export const APPLICATIONS = 'applications';
export const NETWORKS = 'networks';
export const CLUSTERS = 'clusters';
export const PLATFORMS = 'platforms';
export const AFFILIATES = 'affiliates';
export const TYPE = 'type';
export const SUB_TYPE = 'subType';
export const CHANNELS = 'channels';
export const PERIOD = 'period';
export const DESCRIPTION = 'description';

// fields dependencies
export const FORM_FIELDS_DEPENDENCIES = {
  [SUB_TYPE]: [TYPE],
  [APPLICATIONS]: [NETWORKS, PLATFORMS],
  [NETWORKS]: [APPLICATIONS, PLATFORMS, CLUSTERS],
  [CLUSTERS]: [APPLICATIONS, NETWORKS],
  [PLATFORMS]: [APPLICATIONS, NETWORKS],
  [AFFILIATES]: [APPLICATIONS, NETWORKS, CLUSTERS],
};

export const columnMenuConfig = {
  columnMenuCollapsingItem: true,
  columnMenuColorScaleItem: true,
};
export const TYPE_MARKETING = 1;
